exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-details {\n  margin: 1em auto;\n  width: 1000px;\n  background: white;\n  clear: both; }\n  .client-details table {\n    margin: 1.5em;\n    border-collapse: collapse; }\n    .client-details table td {\n      border-bottom: 1px solid #aaaaaa;\n      padding: .5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/clients/views/clientDetailsView/clientDetailsView.component.scss
// module id = ./src/app/modules/clients/views/clientDetailsView/clientDetailsView.component.scss
// module chunks = main